import { socket } from "../index";

const emitGetMessages = (
  roomId: string
) => {
  socket?.emit('GET_MESSAGES', { roomId });
}

export default emitGetMessages;